import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { UncontrolledTooltip, UncontrolledTooltipProps } from 'reactstrap';
import { ErrorBoundary } from '@/library/components/general/ErrorBoundary';

const getTooltipVisibilityModifier = (element: Node) => {
  const openedDrawer = document.getElementById('drawer-container')?.querySelector('.drawer.open');
  const isContained =
    element instanceof HTMLElement ? element.closest('.drawer.open') !== null : false;

  if (openedDrawer && !isContained) {
    return false;
  } else {
    return true;
  }
};

const Tooltip: FC<PropsWithChildren<UncontrolledTooltipProps>> = ({
  target,
  placement,
  innerClassName = 'show-more-tooltip',
  popperClassName = '',
  children,
  modifiers = [],
  ...rest
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);
  const [isTooltipReady, setIsTooltipReady] = useState(false);

  useEffect(() => {
    if (target) {
      setIsTooltipReady(true);
    }
  }, [target]);

  useEffect(() => {
    return () => {
      setIsTooltipReady(false);
    };
  }, []);

  return (
    <ErrorBoundary fallback={null} notifyBugsnag={false}>
      {isTooltipReady && (
        <UncontrolledTooltip
          popperClassName={`${popperClassName} ${!isTooltipVisible ? `d-none` : ''}`}
          target={target}
          placement={placement ?? 'top'}
          innerClassName={innerClassName}
          boundariesElement="window"
          fade={false}
          {...rest}
          modifiers={[
            ...modifiers,
            {
              name: 'tooltipInDrawer',
              enabled: true,
              phase: 'afterWrite',
              fn: ({ state }) => {
                setIsTooltipVisible(getTooltipVisibilityModifier(state.elements.reference as Node));
              }
            }
          ]}
        >
          {children}
        </UncontrolledTooltip>
      )}
    </ErrorBoundary>
  );
};

export default Tooltip;
